import { render, staticRenderFns } from "./ColorSolutions.vue?vue&type=template&id=41920833&scoped=true&lang=pug&"
import script from "./ColorSolutions.vue?vue&type=script&lang=js&"
export * from "./ColorSolutions.vue?vue&type=script&lang=js&"
import style0 from "./ColorSolutions.vue?vue&type=style&index=0&id=41920833&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41920833",
  null
  
)

export default component.exports